"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeCookie = void 0;
const serializeCookie = (name, value, options) => `${name}=${value};${options ? serializeSetCookieOptions(options) : ''}`;
exports.serializeCookie = serializeCookie;
const serializeSetCookieOptions = (options) => {
    const { expires, domain, httpOnly, sameSite, secure, path, maxAge } = options;
    const serializedOptions = [];
    if (domain) {
        serializedOptions.push(`Domain=${domain}`);
    }
    if (expires) {
        serializedOptions.push(`Expires=${expires.toUTCString()}`);
    }
    if (httpOnly) {
        serializedOptions.push(`HttpOnly`);
    }
    if (sameSite) {
        serializedOptions.push(`SameSite=${sameSite}`);
    }
    if (secure) {
        serializedOptions.push(`Secure`);
    }
    if (path) {
        serializedOptions.push(`Path=${path}`);
    }
    if (maxAge) {
        serializedOptions.push(`Max-Age=${maxAge}`);
    }
    return serializedOptions.join(';');
};
